import { createApi } from '@blockworks/platform/api';

import {
    INTERNAL_SLACK_ENDPOINTS,
    PostShareFeedbackRequest,
    PostShareFeedbackResponse,
    PostSlackWebhookBody,
} from './internal-slack.model';

const internalSlackApi = createApi(build => ({
    post: {
        createWebhook: build<any, PostSlackWebhookBody>({
            cachePrefix: 'post-slack-webhooks',
            baseUrl: 'same-origin',
            query: body => {
                return {
                    uri: INTERNAL_SLACK_ENDPOINTS.POST.SLACK_WEBHOOKS(),
                    options: {
                        method: build.Method.Post,
                        body,
                    },
                };
            },
        }),
        shareFeedback: build<PostShareFeedbackResponse, PostShareFeedbackRequest>({
            cachePrefix: 'share-feedback-in-slack',
            baseUrl: 'same-origin',
            query: body => {
                return {
                    uri: INTERNAL_SLACK_ENDPOINTS.POST.SHARE_FEEDBACK(),
                    options: {
                        method: build.Method.Post,
                        body,
                    },
                };
            },
        }),
    },
}));

export { internalSlackApi };
